module.exports = __webpack_public_path__ + "static/media/plus.e6959dc8.svg";